import React from 'react';

const AIIcon = ({ size = 24, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    {/* Outer glow ring */}
    <circle cx="16" cy="16" r="15" stroke="url(#grad)" strokeWidth="1.2" opacity="0.4" />

    {/* Brain / circuit lobes */}
    {/* Left lobe */}
    <path
      d="M10 13 C8 12, 6.5 13.5, 7 15.5 C7.5 17.5, 9 18, 10 17.5"
      stroke="url(#grad)" strokeWidth="1.4" strokeLinecap="round" fill="none"
    />
    {/* Right lobe */}
    <path
      d="M22 13 C24 12, 25.5 13.5, 25 15.5 C24.5 17.5, 23 18, 22 17.5"
      stroke="url(#grad)" strokeWidth="1.4" strokeLinecap="round" fill="none"
    />

    {/* Main brain body */}
    <path
      d="M10 17.5 C10 20, 12 22, 14 21.5 L16 22 L18 21.5 C20 22, 22 20, 22 17.5 L22 13 C22 10.5, 20.5 9, 18.5 9.5 C18 8, 17 7.5, 16 7.5 C15 7.5, 14 8, 13.5 9.5 C11.5 9, 10 10.5, 10 13 Z"
      stroke="url(#grad)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none"
    />

    {/* Center divider line */}
    <line x1="16" y1="9.5" x2="16" y2="21.8" stroke="url(#grad)" strokeWidth="1" strokeDasharray="1.5 1.5" />

    {/* Circuit dots - left */}
    <circle cx="11.5" cy="13" r="1" fill="url(#grad)" />
    <circle cx="11" cy="16.5" r="0.8" fill="#00d4ff" opacity="0.8" />
    <circle cx="13" cy="20" r="0.8" fill="url(#grad)" />

    {/* Circuit dots - right */}
    <circle cx="20.5" cy="13" r="1" fill="url(#grad)" />
    <circle cx="21" cy="16.5" r="0.8" fill="#8b5cf6" opacity="0.8" />
    <circle cx="19" cy="20" r="0.8" fill="url(#grad)" />

    {/* Top antenna */}
    <line x1="16" y1="7.5" x2="16" y2="5" stroke="url(#grad)" strokeWidth="1.2" strokeLinecap="round" />
    <circle cx="16" cy="4.5" r="1.2" fill="url(#grad)" />

    {/* Pulse lines left */}
    <path d="M7 15.5 L5 15.5" stroke="url(#grad)" strokeWidth="1" strokeLinecap="round" opacity="0.6" />
    {/* Pulse lines right */}
    <path d="M25 15.5 L27 15.5" stroke="url(#grad)" strokeWidth="1" strokeLinecap="round" opacity="0.6" />

    <defs>
      <linearGradient id="grad" x1="0" y1="0" x2="32" y2="32" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#00d4ff" />
        <stop offset="100%" stopColor="#8b5cf6" />
      </linearGradient>
    </defs>
  </svg>
);

export default AIIcon;
